export default {"src":"/_next/static/image/public/images/flags/flag_685.0a137c1fd880ab55053fdc60f9e03a3c.svg","height":16,"width":24};